import ApiService from '../../services/api.service'
import TokenService from '../../services/storage.service'

const state = {
    currentLang: (localStorage.getItem('locale')) ? localStorage.getItem('locale') : process.env.VUE_APP_I18N_LOCALE,
    loginPopupStatus: true,
    customer: {},
    usersLoading: false,
    customerPortalUsers: null,
    logoutTime: [],
    loading: false,
}

const getters = {
    loading: state => state.loading,
    currentLang: (state) => {
        return state.currentLang
    },
    usersLoading: (state) => {
        return state.usersLoading
    },
    customerPortalUsers: (state) => {
        return state.customerPortalUsers
    },
    loginPopupStatus: (state) => {
        return state.loginPopupStatus
    },
    customer: (state) => {
        return state.customer
    },
    logoutTime: (state) => {
        return state.logoutTime
    }
}

const actions = {
    setLang({ commit }, value) {
        commit('setLang', value)
    },
    getCustomerPortalUser({ commit }, value) {
        commit('setUserLoading', true);
        ApiService.post('get-customer-portal-users', value).then((result) => {
            commit('setCustomerPortalUsers', result.data.data);
        }).catch((e) => {
            
        })
        .finally(() => {
            commit('setUserLoading', false);
        });
    },
    setLoginPopupStatus({ commit }, value) {
        commit('setLoginPopupStatus', value)
    },
    fetchCustomer({ commit }, customerNo) {
        commit('setLoading', true)
        ApiService.get('fetchcustomer/' + customerNo) //10072
            .then((result) => {
                commit('setCustomer', result.data);
            }).catch((e) => {

            }).finally(() => {
                commit('setLoading', false)
            })
    },
    setCurrentLogoutTime({ commit }) {
        const accessToken = localStorage.getItem("at")
        var formData = new FormData()
        formData.append("accessToken", accessToken)
        
        ApiService.post('/logout-detail', formData)
        .then((result) => {
            commit('setLogoutTime', result);
        }).catch((e) => {
            
        });
    },
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setLang(state, value) {
        state.currentLang = value
    },
    setUserLoading(state, value) {
        state.usersLoading = value
    },
    setCustomerPortalUsers(state, value) {
        state.customerPortalUsers = value
    },
    setLoginPopupStatus(state, value) {
        if (value.event == 'login') {
            state.loginPopupStatus = !value
        } else {
            state.loginPopupStatus = value
        }
    },
    setCustomer(state, data) {
        state.customer = data
    },
    setLogoutTime(state, data) {
        state.logoutTime = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}